import type { ExamsPreset } from "@/types/exams-presets"
import { API_ROOT, HttpClient } from "@/api/httpClient"

export interface ExamPresetPayload {
	name: string
	exams: string[]
}

export default {
	list() {
		return HttpClient.get<ExamsPreset[]>(`${API_ROOT}/doctors/me/exams-presets`)
	},
	create(payload: ExamPresetPayload) {
		return HttpClient.post<ExamsPreset>(`${API_ROOT}/doctors/me/exams-presets`, payload)
	},
	update(presetId: number, payload: ExamPresetPayload) {
		return HttpClient.put(`${API_ROOT}/doctors/me/exams-presets/${presetId}`, payload)
	},
	delete(presetId: number) {
		return HttpClient.delete(`${API_ROOT}/doctors/me/exams-presets/${presetId}`)
	}
}
